// 导出页面为PDF格式
import html2Canvas from 'html2canvas';
import JsPDF from 'jspdf';

let onePageWidth = 593;
let onePageHeight = 832;
let heightSub = 20; //如果页面中加入了padding，margin或者页眉，页脚，这里都要减去对应的高度

function genImages(imageData, opts, page, dom, innerDom) {
  if (imageData.length > 0) {
    opts.scale = 1;
  }
  html2Canvas(document.querySelector('#pdfDom'), opts).then((canvas) => {
    let pageData = canvas.toDataURL('image/jpeg', 1.0);
    imageData.push(pageData);
    let left = imageData.length * onePageWidth * -1 + 'px';
    innerDom.style.left = left;
    if (imageData.length < page) {
      genImages(imageData, opts, page, dom, innerDom);
    }
  });
}

export default {
  install(Vue, options) {
    Vue.prototype.getPdf = (dom, innerDom, title,plusPage = 0) => {
      let height = innerDom.offsetHeight;
      let page = Math.ceil(height / (onePageHeight - heightSub));
      page = parseInt(page) + parseInt(plusPage)      

      innerDom.style.height = onePageHeight + 'px'; //innerDom不可以设置宽度，会导致整个布局左移
      dom.style.height = onePageHeight + 'px';
      dom.style.width = onePageWidth + 'px';
      innerDom.style.columns = `${onePageWidth}px ${page}`;
      var scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop; // 获取页面滚动高度
      var c = document.createElement('canvas');
      var opts = {
        scale: 2,
        canvas: c,
        logging: true,
        allowTaint: false,
        useCORS: true,
        width: onePageWidth,
        height: scrollTop,
        background: '#FFF',
      };
      c.width = onePageWidth * 2;
      c.height = onePageHeight * 2;

      let imageData = [];

      genImages(imageData, opts, page, dom, innerDom);

      let isStop = false;
      let PDF = new JsPDF('', 'pt', 'a4');

      let myInterval = setInterval(() => {
        if (imageData.length == page && !isStop) {
          isStop = true;
          console.log('加载完成，开始导出pdf');
          for (let j = 0; j < page; j++) {
            if (j > 0) {
              PDF.addPage();
            }
            PDF.addImage(
              imageData[j],
              'JPEG',
              0,
              0,
              onePageWidth,
              onePageHeight
            );
          }
          PDF.save(title + '.pdf');
          clearInterval(myInterval);
          setTimeout(() => {
            window.close();
          }, 3000 * 1000);
        }
      }, 100);
    };
  },
};